import { memo } from 'react';

const BzDotsLoader = () => {
    return (
        <span className='pre-loader'>
            <span className='loader-box'>
                <span className='loader-dot'></span>
                <span className='loader-dot'></span>
                <span className='loader-dot'></span>
            </span>
        </span>
    );
};

export default memo(BzDotsLoader);
